import { Typography } from '@mui/material';
import { i18n, useTranslation } from 'next-i18next';
import React from 'react';
import Countdown from 'react-countdown';
import { isNull } from 'util';

interface SpeedDatingCountdownProps {
  countdownEnd: Date;
  handleComplete: () => void;
}

export const SpeedDatingCountdown = (props: SpeedDatingCountdownProps) => {
  const { countdownEnd, handleComplete } = props;
  const { t } = useTranslation();

  const countdownRenderer = (props: any) => {
    const lessThanTenSecondsLeft = props.hours === 0 && props.minutes === 0 && props.seconds <= 10;

    if (lessThanTenSecondsLeft) {
      return (
        <div className="flex flex-row justify-end animate-pulse">
          <Typography variant="h5">{t('meeting:matching-about-to-end')}</Typography>
        </div>
      );
    }

    return (
      <div className="flex flex-row justify-end">
        <div>
          <p className="mr-4 ml-4 mt-1 mb-1 text-2xl">{props.hours < 10 ? '0' + props.hours : props.hours}</p>
          <p className="text-xm ml-4 text-slate-500">{t('account:hours')}</p>
        </div>
        <p className="text-2xl my-1">:</p>
        <div>
          <p className="ml-4 mt-1 mb-1 text-2xl mr-4">{props.minutes < 10 ? '0' + props.minutes : props.minutes}</p>
          <p className="text-xm ml-4 text-slate-500">Min</p>
        </div>
        <p className="text-2xl mt-1 mb-1">:</p>
        <div>
          <p className="ml-4 mt-1 mb-1 text-2xl">{props.seconds < 10 ? '0' + props.seconds : props.seconds}</p>
          <p className="text-xm ml-4 text-slate-500">{!isNull(i18n) && i18n?.t('event:countdown.seconds').substr(0, 3)}</p>
        </div>
      </div>
    );
  };

  return <Countdown date={countdownEnd} renderer={countdownRenderer} onComplete={handleComplete} />;
};
